// en.js
const EN = {
    type: "EN",
    lang: "English",

    // 首页-页眉字符
    index_1: "Home",
    index_2: "About Us",
    index_3: "Company Profile",
    index_4: "Honors & Certifications",
    index_5: "Corporate Culture",
    index_6: "Products",
    index_7: "News",
    index_8: "Support",
    index_9: "Project Cooperation",
    index_10: "After-sales Service",
    index_11: "Downloads",
    index_12: "Hotline",
    // 首页-主体字符
    index_23: "Contact Us",
    index_24_1: "Phone: 15910967510",
    index_25_1: "Email: andaf@sina.com",
    index_27_1: "Address: ",
    index_28_1: "F6-3, Xinfeida Science & Technology Development Center, Shahe, Changping District, Beijing",

    // 首页-页脚字符
    foot_1: "Why Choose Pascal",
    foot_2: "Latest Products",
    foot_6: "Submit",
    foot_7: "Official WeChat",
    foot_8: "Mobile",

    // 手机底部导航栏
    mobile_foot1: "Home",
    mobile_foot2: "Products",
    mobile_foot3: "News",
    mobile_foot4: "Docs",

    // 首页-关于我们模块
    home_about_title: "Pascal Technology",
    home_about_subtitle: "Mastering Core Fluid Technologies",
    home_about_description: "Pascal (Beijing) Fluid Technology Co., Ltd. is a high-tech company dedicated to the R&D of equipment and components in the medical, life sciences, and scientific instruments sectors. Guided by the principles of integrity, professionalism, and efficiency, we continuously innovate upon our mastery of core fluid technologies to deliver high-quality products and services. Our product range—including ultra-precision syringe pumps, plunger pumps, high-pressure infusion pumps, check valves, rotary valves, filters, tubing, and fittings—has earned widespread acclaim for its advanced technology and superior quality. We also have a capable R&D team and top-tier grinding and polishing equipment, enabling rapid customization and end-to-end fluid component integration.",
    home_about_more: "Learn More +",
    home_about_stat1_value: "10",
    home_about_stat1_unit: "yr+",
    home_about_stat1_label: "Years in Fluid Technology",
    home_about_stat2_value: "50",
    home_about_stat2_unit: "+",
    home_about_stat2_label: "Proprietary Precision Products",
    home_about_stat3_value: "300",
    home_about_stat3_unit: "+",
    home_about_stat3_label: "Clients Served Globally",

    // 其他页面
    text1: "Please enter...",
    text2: "Loading...",
    text3: "Consult Now",
    text4: "Company Name",
    text5: "Product Name",
    text6: "Contact Info",
    text7: "Remarks",
    text8: "We support phone, email, and landline contacts, and will get back to you promptly.",
    text10: "Product Details",
    text11: "Product Documentation",
    consultation_tag: "Consultation",
    consultation_page_title: "Why Choose Us",
    consultation_subtitle: "For precision fluid control applications, we focus on dimensional accuracy, material fit, and operating stability so the right solution can be identified faster.",
    consultation_advantage_1_title: "Precision Machining",
    consultation_advantage_1_desc: "We bring micron-level machining experience with attention to consistency in critical dimensions and assembly stability.",
    consultation_advantage_2_title: "Material Matching",
    consultation_advantage_2_desc: "We are familiar with ceramics, engineering plastics, and other materials, and can recommend options based on media and corrosion requirements.",
    consultation_advantage_3_title: "Application Experience",
    consultation_advantage_3_desc: "With experience from OEM equipment and real operating conditions, we help confirm a suitable solution more efficiently.",
    consultation_info_tag: "Key Details",
    consultation_info_title: "Share your application scenario and needs, and we will help match a suitable solution quickly",
    consultation_focus_1_title: "Application Scenario",
    consultation_focus_1_desc: "You can add media type, equipment model, and flow or pressure range so we can assess the fit more quickly.",
    consultation_focus_2_title: "Product Direction",
    consultation_focus_2_desc: "If you already have a target product, model, or replacement need, please mention it so we can check against our current product line.",
    consultation_focus_3_title: "Delivery Needs",
    consultation_focus_3_desc: "If sampling, lead time, or customization is involved, please note it in advance so the right team can follow up.",
    consultation_helper: "After submission, we will contact you as soon as possible and discuss suggestions based on the actual operating condition.",
    consultation_form_tag: "Online Form",
    consultation_form_title: "Share your consultation details",
    consultation_form_desc: "The more complete the information is, the closer our recommendation will be to your actual application.",
    consultation_prefill: "Current product",
    consultation_company_label: "Your company name",
    consultation_company_placeholder: "Please enter your company or organization name",
    consultation_product_label: "Product you'd like to discuss",
    consultation_product_placeholder: "Please enter the product name, model, or application direction",
    consultation_contact_label: "Your contact details",
    consultation_contact_placeholder: "Please enter a phone number, email, or WeChat for a quick follow-up",
    consultation_requirement_label: "Other requirements",
    consultation_requirement_placeholder: "You can add media type, operating conditions, lead time, or customization needs",
    consultation_submit: "Submit Request",
    consultation_submit_error: "Submission failed. Please try again later.",

}
export default EN
